import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL;

const UpdateMeetingStatusRedis = async (payload: any): Promise<{ status: number; data: any }> => {
  try {
    const response = await axios.post(`${HOSTAPI}/connection/setMeetingLive`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response?.status || 500,
      data: error.response?.data || error.message || 'Unknown error',
    };
  }
};

export default UpdateMeetingStatusRedis;
